import { render, staticRenderFns } from "./RecordViewer.vue?vue&type=template&id=77cf4cd3&"
import script from "./RecordViewer.vue?vue&type=script&lang=js&"
export * from "./RecordViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports